import { InputHTMLAttributes, DetailedHTMLProps } from "react";

interface ICheckboxForCarrierStateAppointedForm
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  className?: string;
  label?: string;
  preIcon?: any;
  register?: any;
  validation?: any;
  hasPermission?: boolean;
  secondDiv?: string;
  ref?: any;
  onClick?: (e: any) => void;
  required?: boolean;
}
const CheckboxForCarrierStateAppointedForm: React.FC<ICheckboxForCarrierStateAppointedForm> =
    ({
  name = "text-name",
  type = "checkbox",
  className = "flex justify-center",
  label,
  register,
  validation,
  hasPermission,
  disabled = false,
  onClick,
  required = false,
  ...props
}) => {
  return (
    <div className="space-y-1 w-full text-xs">
      <div className="grid grid-cols-1 gap-1">
        {label && (
          <label
            htmlFor={name}
            className={`flex justify-center flex space-x-1 expandedLabel fontExpand`}
          >
            {label}:{""}
          </label>
        )}
        <div className={`flex justify-center ${required && `gap-1`}`}>
          {required && (
            <div className="flex space-x-1 text-red-500 pr-0.5 font-bold">
              *
            </div>
          )}
          <input
            type="checkbox"
            name={name}
            className={`${className} mr-4 w-4 h-4 border-gray-50 cursor-pointer hover:cursor-pointer`}
            {...register(name, validation)}
            disabled={disabled}
            onClick={onClick}
          />
        </div>
      </div>
    </div>
  );
};
export default CheckboxForCarrierStateAppointedForm;
